/**
 * @module automated-feature
 *
 * Handles automatically opening the chatbox on the automated feature
 * page: olark.com/automated
 */

import { selectOne, getWindow, addClass, removeClass, whenOlarkExists } from './utils/dom-utils';
import { onPath } from './utils/path';

const VISIBLE_CLASS_NAME = 'visible';
const OPERATORS_AWAY_CLASS = 'operators-away';
const TIMEOUT_DURATION = 2500;


// Assuming the window loads properly and olark exists on the page,
// set up the automated demo.
function whenOlark(olark) {

  const button = selectOne('#js-chatbox-countdown-btn');
  const countdown = selectOne('#js-chatbox-countdown');

  // Don't demonstrate this feature if operators are away.
  olark('api.chat.onOperatorsAvailable', () => {
    addClass(button, VISIBLE_CLASS_NAME);
    removeClass(button, OPERATORS_AWAY_CLASS);
  });
  olark('api.chat.onOperatorsAway', () => {
    removeClass(button, VISIBLE_CLASS_NAME);
    addClass(button, OPERATORS_AWAY_CLASS);
  });

  if (button && countdown) {

    button.addEventListener('click', evt => {
      evt.preventDefault();

      // Make sure the chatbox starts off in a shrunken state.
      olark('api.box.shrink');

      // Replace the button with the countdown
      removeClass(button, VISIBLE_CLASS_NAME);
      addClass(countdown, VISIBLE_CLASS_NAME);

      // Expand the chatbox after the timer runs out and populate
      // a new message.
      setTimeout(() => {

        olark('api.box.expand');
        olark('api.chat.sendMessageToVisitor', {
          body: 'This is how Automated Chat works! Let us know if you have any questions.'
        });

        // Replace the countdown with the button
        removeClass(countdown, VISIBLE_CLASS_NAME);
        addClass(button, VISIBLE_CLASS_NAME);

      }, TIMEOUT_DURATION);
    });

  }
}

// If we don't end up with olark on the page, hide the
// automated demo.
function whenNoOlark() {
  const button = selectOne('#js-chatbox-countdown-btn');
  const countdown = selectOne('#js-chatbox-countdown');

  if (button && countdown) {
    removeClass(button, VISIBLE_CLASS_NAME);
    removeClass(countdown, VISIBLE_CLASS_NAME);
  }
}

// only setup the custom class triggers on Olark on automated features page
onPath('/features/automated/', () => {
  whenOlarkExists(whenOlark, whenNoOlark);
});
